export namespace Appliances {
  export const cooking = {
    type: 'cooking',
    icon: 'oven',
    name: 'legrand-app.__LEG_COM_COOKING_APPLIANCES',
  };
  export const radiator = {
    type: 'radiator',
    icon: 'heater',
    name: 'legrand-app.__LEG_RADIATORS',
  };
  export const radiator_without_pilot_wire = {
    type: 'radiator_without_pilot_wire',
    icon: 'heater',
    name: 'legrand-app.__LEG_RADIATORS',
  };
  export const water_heater = {
    type: 'water_heater',
    icon: 'domestic-hot-water',
    name: 'legrand-app.__LEG_COM_WATER_HEATERS',
  };
  export const other = {
    type: 'other',
    icon: 'flash',
    name: 'legrand-app.__LEG_COM_OTHER_APPLIANCES',
  };
  export const electric_charger = {
    type: 'electric_charger',
    icon: 'electric-car',
    name: 'legrand-app.__LEG_COM_EVSES',
  };
  export const light = {
    type: 'light',
    icon: 'light',
    name: 'legrand-app.__LEG_COM_LIGHTS',
  };
  export const fridge_freezer = {
    type: 'fridge_freezer',
    icon: 'fridge',
    name: 'legrand-app.__LEG_COM_FRIDGES',
  };
  export const washing_machine = {
    type: 'washing_machine',
    icon: 'washing',
    name: 'legrand-app.__LEG_COM_WASHING_MACHINES',
  };
  export const tumble_dryer = {
    type: 'tumble_dryer',
    icon: 'dryer',
    name: 'legrand-app.__LEG_COM_DRYERS',
  };
  export const dishwasher = {
    type: 'dishwasher',
    icon: 'dishwasher',
    name: 'legrand-app.__LEG_COM_DISHWASHERS',
  };
  export const multimedia = {
    type: 'multimedia',
    icon: 'multimedia',
    name: 'legrand-app.__LEG_COM_MULTIMEDIA',
  };
  export const router = {
    type: 'router',
    icon: 'internet-box',
    name: 'common-app.__LEG_COM_ROUTER',
  };
  export const air_conditioner = {
    type: 'air_conditioner',
    icon: 'air-conditioner',
    name: 'legrand-app.__AIR_CONDITIONERS',
  };
  export  const fan = {
    type: 'fan',
    icon: 'fan',
    name: 'legrand-app.__CEILING_FAN',
  };
  export  const rest_of_home = {
    type: 'rest_of_home',
    icon: 'elsewhere',
    name: 'legrand-app.__LEG_REST_OF_THE_HOME',
  };
  export const garage_door = {
    type: 'garage_door',
    icon: '',
    name: 'legrand-app.__LEG_COM_MULTIMEDIA',
  };
};

